import * as React from "react";
import { Link } from "react-router-dom";
import ReactToPrint from 'react-to-print';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Breadcrumb, BreadcrumbItem, Card, Row, Col, Button } from "reactstrap";

const PageLayout = ({ title, children, optionalNav }) => {

  const printingArea = React.createRef()

  return (
    <div ref={printingArea}>
      <Container className="mb-3 datatable-piramis" id="MainPageContainer">
        <Row>
          <Col className="breadcrumbline">
            <Breadcrumb>
              <BreadcrumbItem active>
                <Link to="/"><FontAwesomeIcon icon="home" className="mr-2" /></Link>
              </BreadcrumbItem>
              {optionalNav && (
                <BreadcrumbItem active>
                  <Link to={optionalNav.link}>{optionalNav.text}</Link>
                </BreadcrumbItem>
              )}
              <BreadcrumbItem active>
                <span className="text-dark font-weight-bold">{title}</span>
              </BreadcrumbItem>
            </Breadcrumb>
            {false && <ReactToPrint
              trigger={() => (
                <Button
                  style={{ position: 'absolute', right: '25px', top: "8px" }}> <FontAwesomeIcon icon="print" /></Button>
              )}
              content={() => printingArea.current}
            />}
          </Col>
        </Row>
        <Row>
          <Col>
            {children}
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default PageLayout;
